module.exports = __webpack_public_path__ + "img/orange-ball-1.03a9e7c6.svg";